import {call, put, takeEvery, select} from 'redux-saga/effects';
import {onChartLoad, onChartLoadFail, onChartLoadSuccess, onInit, onInitFail, onInitSuccess} from "./actions";
import {dashboardOnInit, loadCharts} from "../api";

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

function* fetchInitData(action) {
    try {
        const dashboard = yield select(state => state.dashboard);

        const filter = {
            date: formatDate(dashboard.currentDate),
            restaurantId: dashboard.currentRestaurantId,
        }
        const response = yield call(dashboardOnInit, filter)
        yield put(onInitSuccess(response))
    }
    catch (e) {
        yield put(onInitFail())
    }
}


function* fetchChartData(action) {
    try {
        const dashboard = yield select(state => state.dashboard);

        const filter = {
            group: dashboard.chartGroup,
        }
        const response = yield call(loadCharts, filter)
        yield put(onChartLoadSuccess(response))
    }
    catch (e) {
        yield put(onChartLoadFail())
    }
}



function* mySaga() {
    yield takeEvery(onInit().type, fetchInitData);
    yield takeEvery(onChartLoad().type, fetchChartData);
}

export default mySaga;
